import { useAtomValue } from "jotai";
import { useMemo } from "react";

import { CardCategoryEnum } from "@sorcery/db";

import { decklistJotai, sideboardJotai } from "~/state/deckJotai";

export const DeckCardCount = () => {
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const decklist = useAtomValue(decklistJotai)!;
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const sideboard = useAtomValue(sideboardJotai)!;

  const spellbookCount = useMemo(
    () =>
      decklist
        .filter((dc) => {
          return dc.card.guardian?.category === CardCategoryEnum.Spell;
        })
        .reduce((a, c) => a + Number(c.quantity), 0),
    [decklist],
  );

  const atlasCount = useMemo(
    () =>
      decklist
        .filter((dc) => {
          return dc.card.guardian?.category === CardCategoryEnum.Site;
        })
        .reduce((a, c) => a + Number(c.quantity), 0),
    [decklist],
  );
  const sideboardCount = useMemo(
    () => sideboard.reduce((a, c) => a + Number(c.quantity), 0),
    [sideboard],
  );
  return (
    <div className="w-fit">
      {spellbookCount} Spellbook / {atlasCount} Atlas{" "}
      {!!sideboardCount && <>/ {sideboardCount} Sideboard</>}
    </div>
  );
};
